import { apiHolder as api, apis } from 'api';
import React, { useCallback, useMemo } from 'react';
import styles from './cloudMailSearchEntry.module.scss';
import { useActions, useAppDispatch, useAppSelector, MailActions } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { getIn18Text } from 'api';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const CloudMailSearchEntry = () => {
    const dispatch = useAppDispatch();
    const reducer = useActions(MailActions);
    const { extraSearchCloudMailListObjStatus, extraSearchCloudMailListObj, mailSearchAccount, mailSearchStateMap, mailSearchMoreAccounts } = useAppSelector(state => state.mailReducer);
    const cloudMailListTotal = useMemo(() => {
        if (extraSearchCloudMailListObj)
            return (extraSearchCloudMailListObj === null || extraSearchCloudMailListObj === void 0 ? void 0 : extraSearchCloudMailListObj.total) || 0;
        return 0;
    }, [extraSearchCloudMailListObj]);
    const entryShow = useMemo(() => {
        if (process.env.BUILD_ISWEB || process.env.BUILD_ISEDM || mailSearchMoreAccounts) {
            return false;
        }
        if (!mailSearchAccount || !mailSearchStateMap)
            return false;
        const searchType = mailSearchStateMap[mailSearchAccount];
        if (searchType === 'local') {
            if (extraSearchCloudMailListObjStatus === 'success') {
                return cloudMailListTotal > 0;
            }
            else {
                return !!extraSearchCloudMailListObjStatus;
            }
        }
        else {
            return false;
        }
    }, [mailSearchAccount, mailSearchStateMap, extraSearchCloudMailListObjStatus, cloudMailListTotal, mailSearchMoreAccounts]);
    const showAll = useCallback(() => {
        if (!mailSearchAccount)
            return;
        reducer.beforeSearchServer({ account: mailSearchAccount });
        dispatch(Thunks.loadSearchMailList({
            startIndex: 0,
            noCache: false,
        }));
        trackApi.track('pcMail_executeMailSearch', {
            searchMode: '全文搜索（云端）',
        });
    }, [mailSearchAccount]);
    const searchCloudMail = () => {
        reducer.resetExtraSearchCloudMailList({});
        dispatch(Thunks.searchCloudMailListExtra({
            startIndex: 0,
        }));
    };
    return (React.createElement(React.Fragment, null, entryShow && (React.createElement("div", { className: styles.cloudMailSearchEntry },
        extraSearchCloudMailListObjStatus === 'pending' && React.createElement(React.Fragment, null, getIn18Text('ZHENGZAISOUSUOYUNDUANYOUJIAN')),
        extraSearchCloudMailListObjStatus === 'success' && (React.createElement(React.Fragment, null, cloudMailListTotal > 0 ? (React.createElement(React.Fragment, null,
            getIn18Text('TONGSHIGONGFAXIAN'),
            cloudMailListTotal,
            getIn18Text('FENGYUNDUANYOUJIANSHIFOU'),
            ' ',
            React.createElement("span", { className: styles.showAll, onClick: showAll }, getIn18Text('ZHANSHIQUANBU')))) : (''))),
        extraSearchCloudMailListObjStatus === 'fail' && (React.createElement(React.Fragment, null,
            getIn18Text('YUNDUANSOUSUOSHIBAI'),
            React.createElement("span", { className: styles.showAll, onClick: searchCloudMail }, getIn18Text('SOUSUOYUNDUANYOUJIAN'))))))));
};
export default CloudMailSearchEntry;
